import { selectCurrentHotelId } from 'accessors'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import AvatarIcon from 'features/EmailCampaign/EditEmail/EmailTemplate/Avatar'
import FileUploadDialog from 'features/Messaging/FileUploadDialog'
import useBrand from 'hooks/useBrand'
import mjml2html from 'mjml-browser'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import hotelApi from 'services/api/hotel'

import getBaseEmailTemplate from './baseTemplate'
import styles from './EmailTemplate.module.scss'

const EmailTemplate = ({ fromAddress = 'hotel@hotelWebsite.com' }) => {
  const [heroImg, setHeroImg] = useState(
    'https://cdn.swaypay.io/assets/sample-email-images/hero.jpg'
  )

  const [isShowingUploadDialog, setIsShowingUploadDialog] = useState(false)

  function uploadImage(file) {
    setHeroImg(file.temporaryUrl.tempPublicPath)
    setIsShowingUploadDialog(false)
  }

  const currentHotelId = useSelector(selectCurrentHotelId)
  const [hotelDetails, setHotelDetails] = useState()
  const [isErred, setIsErred] = useState(false)
  const [subject, setSubject] = useState('This is the email subject')
  const [ctaText, setCtaText] = useState('Get special offers')

  const { colors } = useBrand()

  const brand = useBrand()

  useEffect(() => {
    hotelApi
      .getDetails(currentHotelId)
      .then(hotelData => setHotelDetails(hotelData.subsidiary))
      .catch(() => setIsErred(true))
  }, [currentHotelId])

  const [title, setTitle] = useState('Enter email title')
  const [description, setDescription] = useState(
    'Blandit tristique ante at sed id at lorem sem. Est libero erat felis purus fames lacus lectus tellus vitae. Fames rutrum est bibendum sem duis maecenas dolor accumsan nibh bibendum sem duis maecenas dolor'
  )

  if (isErred) return <div>Something went wrong</div>

  if (!hotelDetails) return <LoadingIndicator />

  const source = getBaseEmailTemplate({
    brand,
    hotelDetails,
    colors,
    coloredLogoUrl: 'https://cdn.swaypay.io/assets/sample-email-images/coloredLogo.png',
    whiteLogoUrl: 'https://cdn.swaypay.io/assets/sample-email-images/whiteLogo.png',
    sections: {
      main: {
        heroImgUrl: heroImg,
        title,
        description,
        cta: ctaText
      },
      aboutHotel: {
        title: 'About our hotel',
        description:
          'Blandit tristique ante at sed id at lorem sem. Est libero erat felis purus fames lacus lectus tellus vitae. Fames rutrum est bibendum sem duis maecenas dolor accumsan nibh bibendum sem duis maecenas dolor',
        photos: [
          'https://cdn.swaypay.io/assets/sample-email-images/hotelPhoto1.jpg',
          'https://cdn.swaypay.io/assets/sample-email-images/hotelPhoto2.jpg',
          'https://cdn.swaypay.io/assets/sample-email-images/hotelPhoto3.jpg'
        ]
      },
      address: {}
    }
  })

  return (
    <div className={styles.wrapper}>
      {isShowingUploadDialog && (
        <FileUploadDialog
          handleUploadedFiles={uploadImage}
          handleClose={() => setIsShowingUploadDialog(false)}
          acceptedFileTypes={['image/*']}
        />
      )}
      <div className={styles.formHolder}>
        <div
          className={styles.heroImgHolder}
          style={{ backgroundImage: `url(${heroImg})` }}
        >
          <button
            className={styles.changePhotoButton}
            onClick={() => setIsShowingUploadDialog(true)}
          >
            Change photo
          </button>
        </div>
        <div className={styles.formInputs}>
          <label className={styles.inputHolder}>
            <div className={styles.label}>Email subject</div>
            <input
              type="text"
              onChange={e => setSubject(e.target.value)}
              value={subject}
            />
          </label>
          <label className={styles.inputHolder}>
            <div className={styles.label}>Title</div>
            <input type="text" onChange={e => setTitle(e.target.value)} value={title} />
          </label>
          <label className={styles.inputHolder}>
            <div className={styles.label}>Description</div>
            <textarea
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </label>
          <label className={styles.inputHolder}>
            <div className={styles.label}>Button text</div>
            <input
              type="text"
              onChange={e => setCtaText(e.target.value)}
              value={ctaText}
            />
          </label>
        </div>
      </div>
      <div className={styles.previewSidebar}>
        <div className={styles.emailHeader}>
          <div className={styles.subjectText}>{subject}</div>
          <div className={styles.emailLineGroup}>
            <AvatarIcon className={styles.avatarIcon} />
            <div>
              <div>
                <div className={styles.hotelName}>{hotelDetails.hotelName}</div>
                <div className={styles.fromAddress}>{`<${fromAddress}>`} </div>
              </div>
            </div>
          </div>
        </div>
        {source && (
          <div
            className={styles.emailHolder}
            dangerouslySetInnerHTML={{ __html: mjml2html(source).html }}
          />
        )}
      </div>
    </div>
  )
}

export default EmailTemplate
